module.exports = __webpack_public_path__ + "img/2.ec0ca0bc.png";